/* ── Bara Bros Coupon Merchandising — bb-coupon-merchandising.js ── */
(function () {
  'use strict';

  if (window.__bbCMLoaded) return;
  window.__bbCMLoaded = true;

  var PAGE_DATA_URL   = '/apps/bb-wishlist/coupons/page-data';
  var CACHE_KEY       = 'bb_cm_pagedata';
  var CACHE_TTL_MS    = 5 * 60 * 1000; /* 5 minutes */

  /* ── Fetch page-data with sessionStorage cache ── */
  function fetchPageData(cb) {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && cached._ts && (Date.now() - cached._ts) < CACHE_TTL_MS) {
          cb(cached.data);
          return;
        }
      }
    } catch (e) { /* ignore */ }

    fetch(PAGE_DATA_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ _ts: Date.now(), data: d })); } catch (e) { /* ignore */ }
        cb(d);
      })
      .catch(function () { cb(null); });
  }

  /* ── Utility ── */
  function escHTML(s) {
    return String(s || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function expiryLabel(expiresAt) {
    if (!expiresAt) return null;
    var ms = new Date(expiresAt).getTime() - Date.now();
    if (ms <= 0) return null;
    var days  = Math.floor(ms / 86400000);
    if (days > 7) return null;
    if (days > 0) return 'Expires in ' + days + ' day' + (days === 1 ? '' : 's');
    var hrs = Math.floor(ms / 3600000);
    if (hrs > 0) return 'Expires in ' + hrs + ' hour' + (hrs === 1 ? '' : 's');
    return 'Expiring soon';
  }

  function minOrderLabel(minOrder) {
    if (!minOrder || minOrder <= 0) return null;
    var v = parseFloat(minOrder);
    return 'Min. order $' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  /* ── Pick best coupon from unused wallet coupons + eligible campaigns ──
     Priority: wallet coupons (already earned) > campaigns (earn now)
     Within each: highest value first, then soonest expiry
  ── */
  function pickBestCoupon(pageData) {
    if (!pageData || !pageData.ok) return null;

    var unused   = (pageData.groups && pageData.groups.unused) || [];
    var campaigns = pageData.campaigns || [];
    var walletIds = new Set(
      (pageData.wallet && pageData.wallet.coupons ? pageData.wallet.coupons : [])
        .map(function (c) { return String(c.id); })
    );

    /* Best unused wallet coupon (status === 'unused') */
    if (unused.length > 0) {
      return { source: 'wallet', coupon: unused[0] };
    }

    /* Best eligible campaign not yet in wallet */
    var available = campaigns.filter(function (c) {
      return c && c.id && !walletIds.has(String(c.id));
    });
    if (available.length > 0) {
      return { source: 'campaign', coupon: available[0] };
    }

    return null;
  }

  /* ── hasActiveCoupons: true if there is anything worth showing ── */
  function hasActiveCoupons(pageData) {
    if (!pageData || !pageData.ok) return false;
    var unused = (pageData.groups && pageData.groups.unused) || [];
    if (unused.length > 0) return true;
    var campaigns = pageData.campaigns || [];
    var walletIds = new Set(
      (pageData.wallet && pageData.wallet.coupons ? pageData.wallet.coupons : [])
        .map(function (c) { return String(c.id); })
    );
    return campaigns.some(function (c) { return c && c.id && !walletIds.has(String(c.id)); });
  }

  /* ── Populate and reveal product blocks ── */
  function populateProductBlock(el, pageData) {
    var showBestCode  = el.getAttribute('data-show-best-code')  !== 'false';
    var showMinOrder  = el.getAttribute('data-show-min-order')  !== 'false';
    var showExpiring  = el.getAttribute('data-show-expiring')   !== 'false';

    var best = pickBestCoupon(pageData);

    if (!best) {
      el.style.display = 'none';
      return;
    }

    var coupon = best.coupon;

    /* Update subtitle */
    var subtitleEl = el.querySelector('[data-bb-cm-subtitle]');
    if (subtitleEl && best.source === 'wallet') {
      subtitleEl.textContent = 'You have a coupon ready — copy the code and paste it at checkout.';
    }

    /* Code row */
    if (showBestCode && coupon.code && best.source === 'wallet') {
      var codeRow = el.querySelector('[data-bb-cm-code-row]');
      var codeEl  = el.querySelector('[data-bb-cm-code]');
      if (codeRow && codeEl) {
        codeEl.textContent = coupon.code;
        codeRow.style.display = '';
      }
    }

    /* Expiring */
    if (showExpiring) {
      var expiry = expiryLabel(coupon.expires_at || coupon.end_date);
      var expiringEl = el.querySelector('[data-bb-cm-expiring]');
      if (expiringEl && expiry) {
        expiringEl.textContent = '⏰ ' + expiry;
        expiringEl.style.display = '';
      }
    }

    /* Min order */
    if (showMinOrder) {
      var minAmt = coupon.minimum_order || coupon.min_order_amount;
      var minLabel = minOrderLabel(minAmt);
      var minEl = el.querySelector('[data-bb-cm-min-order]');
      if (minEl && minLabel) {
        minEl.textContent = minLabel;
        minEl.style.display = '';
      }
    }

    el.style.display = '';

    /* Wire copy button */
    var copyBtn = el.querySelector('[data-bb-cm-copy]');
    if (copyBtn && coupon.code) {
      copyBtn.addEventListener('click', function () {
        copyToClipboard(coupon.code, copyBtn);
      });
    }
  }

  /* ── Copy to clipboard ── */
  function copyToClipboard(text, btn) {
    var orig = btn.textContent;
    function done() { btn.textContent = 'Copied!'; setTimeout(function () { btn.textContent = orig; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () { fallbackCopy(text, done); });
    } else {
      fallbackCopy(text, done);
    }
  }

  function fallbackCopy(text, cb) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
    document.body.appendChild(ta);
    ta.focus(); ta.select();
    try { document.execCommand('copy'); cb(); } catch (e) { /* silent */ }
    document.body.removeChild(ta);
  }

  /* ── Resolve badge label from personalized_rewards priority ── */
  function personalizedBadgeLabel(pageData) {
    var pr = pageData && pageData.personalized_rewards;
    if (!pr || !pr.priority) return null;
    switch (pr.priority) {
      case 'vip_tier':           return 'VIP Reward Available';
      case 'points_waiting':     return 'Earn Points';
      case 'expiring_coupon':    return 'Coupon Expiring Soon';
      case 'best_wallet_coupon': return 'Coupon Saved';
      case 'guest':              return 'Collect Coupons';
      default:                   return null;
    }
  }

  /* ── Main init ── */
  function init() {
    var badges   = Array.from(document.querySelectorAll('[data-bb-cm-badge]'));
    var products = Array.from(document.querySelectorAll('[data-bb-cm-product]'));
    var banners  = Array.from(document.querySelectorAll('[data-bb-cm-banner]'));

    if (!badges.length && !products.length && !banners.length) return;

    fetchPageData(function (pageData) {
      var active     = hasActiveCoupons(pageData);
      var badgeLabel = personalizedBadgeLabel(pageData);

      /* Badges: show/hide; update copy when personalized label is available */
      badges.forEach(function (el) {
        el.style.display = active ? '' : 'none';
        if (active && badgeLabel && el.getAttribute('data-bb-cm-badge-personalize') !== 'false') {
          el.textContent = badgeLabel;
        }
      });

      /* Product blocks: populate and show */
      products.forEach(function (el) {
        if (active) {
          populateProductBlock(el, pageData);
        }
        /* else stays display:none */
      });

      /* Banners: show/hide only (CTA already in HTML) */
      banners.forEach(function (el) {
        el.style.display = active ? '' : 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
